import { observer } from "mobx-react";
import React from "react";
import { ChatMeeting } from "@fidget/common/components/chat/chatMeeting";
import { IMeetingChatItem } from "../../models/room/chat/items";

interface Props {
  item: IMeetingChatItem;
}

/**
 * Shows information about a scheduled meeting
 */
export const Meeting: React.SFC<Props> = observer(({ item }) => {
  const { start, duration, agent, changed, meetingStatus } = item;
  return (
    <ChatMeeting
      start={start}
      duration={duration}
      agent={agent}
      meetingStatus={meetingStatus}
      changed={changed}
      widgetStyle={false}
    />
  );
});
